import { useState, useEffect } from "react";
import type { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import type { TAppliedRanges } from "@app/dashboard/types/innerLayout/date-ranges";
import { getLang } from "@app/dashboard/utils/localStorageUtils";
import { isoFormattedDateRange } from "@app/dashboard/utils/dateRangePicker";
import DateRanges from "@app/dashboard/components/inner_layout/DateRanges";

import styles from "./header.module.scss";


export const Header = ({
  isTableLoading,
  setDateRange
}: {
  isTableLoading: boolean,
  setDateRange: Dispatch<SetStateAction<{
    created_at_from: string;
    created_at_to: string;
  }>>
}) => {
  const { t } = useTranslation();
  const lang = getLang();

  const [appliedRanges, setAppliedRanges] = useState<TAppliedRanges>({});

  const { start: startDate, end: endDate, index: rangeIndex, name: rangeName } = appliedRanges;


  useEffect(() => {
    if (startDate && endDate) {
      const formattedDateRange = isoFormattedDateRange([startDate, endDate] as [Date, Date]);
      setDateRange({
        created_at_from: formattedDateRange.start_date,
        created_at_to: formattedDateRange.end_date,
      });
    };
  }, [appliedRanges, lang]);


  return (
    <div className={styles["header"]}>

      <div className={styles["header__title"]}>
        {t('innerLayout.disputesPage.title')}
      </div>

      <div className={styles["header__date-picker"]}>
        <DateRanges
          lang={lang}
          appliedRanges={appliedRanges}
          handleRangesChange={(ranges) => setAppliedRanges(ranges)}
          disabled={isTableLoading}
        />
      </div>
    </div>
  )
}
